module.exports = __webpack_public_path__ + "img/ico24-inbox-primary.dd04ff63.svg";